import React from 'react';
import { Footer } from '@bumble/app/components/Footer';
import useHideNavBarContent from '@bumble/app/hooks/use-hide-navbar-content';
import { COLORS } from '@bumble/app/theme';
import { Box, SxProps } from '@mui/material';

interface PageContentProps {
  hideNavContent?: boolean;
  sx?: SxProps;
  bgColor?: string;
}

function PageContent({
  children,
  hideNavContent = false,
  sx,
  bgColor = COLORS.BACKGROUND,
}: React.PropsWithChildren<PageContentProps>) {
  useHideNavBarContent({ hide: hideNavContent });

  return (
    <Box
      sx={{
        width: '100%',
        minHeight: hideNavContent ? '100vh' : 'calc(100vh - 76px)',
        background: bgColor,
        display: 'flex',
        flexDirection: 'column',
        borderRadius: '8px 8px 0px 0px',
        padding: '20px',
        paddingBottom: 0,
        // border: `1px solid ${COLORS.PRIMARY}`,
        ...sx,
      }}
    >
      {children}
      <Footer />
    </Box>
  );
}

export default PageContent;
